import { render, staticRenderFns } from "./RestoranIc.vue?vue&type=template&id=2190e71c&scoped=true&"
import script from "./RestoranIc.vue?vue&type=script&lang=js&"
export * from "./RestoranIc.vue?vue&type=script&lang=js&"
import style0 from "./RestoranIc.vue?vue&type=style&index=0&id=2190e71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190e71c",
  null
  
)

export default component.exports